export const men_articles = [
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/17/will-the-lions-learn-from-last-years-collapse-what-to-expect-this-ivy-league-mens-basketball-season/",
        article_title: "Will the Lions learn from last year’s collapse? What to expect this Ivy League men’s basketball season",
        article_authors: "Andrew Vincenti",
        image_url: "https://www.columbiaspectator.com/resizer/v2/DRFQPKJYZFCH7NWY3C5XGQ4PLQ.jpg?auth=cc2d6ae454e1f4ac9b7bedd903eb86520f324aba9074b93b0a8c65257a125c19"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/20/mens-basketball-welcomes-six-new-lions-to-the-2025-26-lineup/",
        article_title: "Men’s basketball welcomes six new Lions to the 2025-26 lineup",
        article_authors: "Annie Han",
        image_url: "https://www.columbiaspectator.com/resizer/v2/CLM673L7KFAHFPTUC3DZMUW7VA.png?auth=2f7cccb7301488c2e986921640f4b80f8fddac9bd37e118c9feea4d25af34cb0"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/19/from-first-year-tragedies-to-career-highs-junior-forward-richard-nweke-reflects-on-his-path-back-to-the-court/",
        article_title: "From first-year tragedies to career highs: Junior forward Richard Nweke reflects on his path back to the court",
        article_authors: "Emily Michaelsen",
        image_url: "https://www.columbiaspectator.com/resizer/v2/DWEX3EPDAJCVDMZUJ2HXOMYIBM.jpg?auth=57cbd333bd4985b1ee8998faffd606d48e748663ba32b6281b69fa35034c59d6"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/20/introducing-the-new-mens-basketball-coaching-staff/",
        article_title: "Introducing the new men’s basketball coaching staff",
        article_authors: "Holden Lombardo",
        image_url: "https://www.columbiaspectator.com/resizer/v2/CBTDIWMPENF6JAH45IUBY2DTM4.jpg?auth=fae51a94af3f188bb2e07bbe520aa71b7b9cce4646ad59bb675fc8a8e4ac232d"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/20/how-kevin-hovde-is-making-mens-basketball-his-own/",
        article_title: "How Kevin Hovde is making men’s basketball his own",
        article_authors: "Kaya Quebada & Andrew Vincenti",
        image_url: "https://www.columbiaspectator.com/resizer/v2/XGNF3KE5EBEJJBGPFQQP332J3M.jpg?auth=92d20e89acd1855c5db63d7fb8662459a28b3b0c916c71cf0c36c710cf20d09d"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/10/mens-basketball-rebounds-with-three-straight-wins-after-midseason-slip/",
        article_title: "Men’s basketball rebounds with three straight wins after midseason slip",
        article_authors: "Andrew Vincenti",
        image_url: "https://www.columbiaspectator.com/resizer/v2/RNMXXQ33KBCCFB7DTVRU42TGNU.jpg?auth=28ac94947bfa2cfdc361899b13244e3b827d9db6d6effd4c01eabf67a80a0f13"
    },
];
